import axios from "axios";
import ServiceStorage from "./../services/service.storage";

import { ConfigLink } from "../routes/configLinks";
import SwalMessage from "../../app/pages/_Components/SwalMessage";
import _ from "lodash";

const env = process.env;
const ServiceApi = axios;

ServiceApi.defaults.timeout = 120000;
ServiceApi.defaults.baseURL = window.location.href.includes("softexpert.ir") ? env.REACT_APP_API_URL : env.REACT_APP_API_URL2;
//ServiceApi.defaults.baseURL = 'https://localhost:9004';
ServiceApi.defaults.headers.common['Authorization'] = 'AUTH TOKEN';

ServiceApi.interceptors.request.use(
  async (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

ServiceApi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const originalConfig = error.config;
    if ((error?.response?.status === 401 || error?.response?.status === 403) && !originalConfig._retry) {
      originalConfig._retry = true;
      try {
        const rs = await ServiceApi.post("api/Account/RefreshToken", {
          refreshToken: ServiceStorage.getRefreshToken()
        });
        if (rs.succeeded) {
          ServiceStorage.setToken(rs.data.accessToken, rs.data.refreshToken);
          originalConfig.headers.Authorization = "Bearer " + rs.data.accessToken;
          axios.defaults.headers.common["Authorization"] = "Bearer " + rs.data.accessToken;
        }
        else {
          ServiceApi.logout();
          window.location.href = "/login";
        }
        return ServiceApi(originalConfig);
      } catch (_error) {
        return Promise.reject(_error);
      }
    }
    return Promise.reject(ServiceApi.getErrorText(error));
    //return Promise.reject(error);
  },
);

ServiceApi.setToken = () => {
  const access_token = ServiceStorage.getAccessToken();
  if (access_token != null) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + access_token;
    //axios.defaults.withCredentials=true;
    //axios.defaults.headers.common["Cookie"] = ".AspNetCore.Identity.Application=CfDJ8IO20u3Ju2xArhoNw-i9Hzyp1HieA38bXxkWabYFFa8UOy7fupaU6kChHztGG3ZthxjT8pmWF1hBT3a6jGrP7qlr3I5xxtHi-jU4cGpfHCsOw0lh8X5iD7P-qQkm58vpFdQSTjWSnZEMn_0TuiulIdFBZa9XTiuCax2DfEkjXp-vDpY3vxLuus8U69y51BgU6_8acZfBqojgcYzEciQP10kaCE52MaAtgPvCshNeR54keYTjSEmmrk1zGEPHD1xdwedkKp86Wb7BIvjR6nIQzP_l1oc1vqYLIfX-Rsjp1IAcQPtWgsevOE5JRg_eD5e_C_ipCTLjUmU9AyGV0XoP03PZ5d-HJiRaotP_rYr1dzu1CxseAjBCUXjp72t79BCk2UbYEQBdh3U9nAI7BKIozQA3NX4jXvYdh8T0k5tvjvwpzf1qJzcKI8YQthCqwpaEEA7doasiQbmzd-q_MBVC8FZJZx883b9Bdn4TFvsKNtew023cFreSW-XE2ivYjgOTI6TxEHbsplqe9OprOaTz7i-Z_EEGk2pLeEgHDH74joyijPKpnStOY5H7d5glpRTV8gGKRaqdXoDp5xKlQVQEAD7NrfdhBqx_KXQslzz4whaNHq8SIQwIr72KdumwxGeCOuczJ2BeGoSvLsr2c_XHGblNDqI5krFEEqZr--CifA2wt4UV21oDvrCMuBlNqnigngqAZaOBrBmoL6Dq1AM6UI_R9HgvW4p-whX4VMq0wwNfgbNg3w0S13AcsEUHqKFhVsFr3bjmvtR8cXwxH3UywMuh56bQMe4qONYtV4-EzTnDqDF92eQcBMigAFZ7Cx5iNPUCBLTRRHZNuiDNKH9_0L_0KUejSBSC2gO546eNiXXaaZKh31dTIsFMzI4m254XYXd42qymj8TPgS7XT4C7f8mJ8_o63if1VDc9vtou_3B9EX_bzRYrgs2JX0iOBxwCkpJzRSHkuPeDMvNUBfLUK1x8kjmqX9yBloOEh5P8fad5KfFVGpiuFdT6fRnW9H9Gqkwu0h5PCOgheB4ctjjKkHHCuePrdUVfAH88pEDmxzK-2IBTyf1nFXarSNzpDn9jjosTYgklV_XzjLjs0XbesPoVRwuc5UQ5NSFGlQ7WXog_WVs-48kdO1zx4T9CArH3sS6de7JoqESWGIAh4wttnG4mRaYC4Ldn-KkN546_mWBaIXu-JF7PP18Ppn0GGxqXJRMHCTe1VzLyrB1k4pJbMf4zZeH9I8SlZiI8-G9gNkyn28zH01vbuUhR6QlAc51smK5hhD7RIdNjw0wXfxeZ3QGQuKgl8EJTvckZqiVCgytvfNvlGxsU53g4XTec3RIN1tQbQ9jXOTfIP70NZeW6luy-KrWISK3_VGgMk-zODUdBDW1vp6NNvf1igBPa4dHhXv_j3T16gjKyFwRgQtMps0P-axbVjdXvtBEf_6DoLpVQnFAYc_2X1FPqzBkeQpJBc0aHnHIKF6XQjBgeZMX6hBN2Vov39JN_g9ee5XSEGCp7AhkNxD3OudkqY7ayyGERl-Z3jfNRO6Ad75SBGwQnPWGya85hsvqUeskhCUMOSjnvYm_r4nSTYmowiuBpFpoNLIqV7kK2U0p28Vjy6JLQ8_Ma8hfNct-JTH5Tcy3dTl6-ZVXOie-9qpYdcDlbAM0OvFRmJ_0Yvrvr94wIP3QAf5zJS4sOa0ACWt66JXw1KFaqqzTR59bVZgbmUiSTBd7ZnAGEMlR3xVoHZRy499CrQ8F1tLOB7OWOh46y9eVAZa0qbTsKuDGFkiuTCQPjEgZmC0Gl679-j22bUwalDbiFL5FHAYvWl0V4xleuOW7X_EshuMkAskXJ3eBkIyxuWGNqYAdR-s0WIFV0lBquzHYsj2AnViIhopRj-PYGJce50Ux_zmjn_Hi_PSCvygCOII8sK9p9oQYxQN0aFeCI_3pNGyb1BfbTKuFz6wOrASYjtjg09jXyZBlz66RKpXn-wFBEnPLlMmUfG0_u9Y5OIBxF2Ea9Nm-pjgDEt9WwU0ib7585cXVgxIVYDsbNMkztxh-BZ_4JDgDXKNhkOLP7L-FHsH0l9neKB31cHxnoUnwLRRDVjo9xFbFIQsT9bmmk4tnYzSB89A7d2p9f1z1XrL-9bwK3FioE-BzZV1WRt82Unz7tiGKmQqcm-ryoxGrT70Vjp6cABUm335iyyXuOCjHm9xkaqQaMb80XUYZnypZHVfWZqgobNcTfN0aPkXZZ04SGMUJUVG2J-zpJrlQdu6lBzLYCVtSMEfT8ch9sTcnB2Q1aswZw1TKcjyUetxxsvFLPmeFmDpLW0Q2BhoDfCMkxoxQcXFXbZvFi_i9AoHxva19TmXnPGf_XD6WIdbCaiwOQft9-9NN1m4udblhFZnYffgGe3W7Hb34oz2X51hidh1UiV2VJlUYZSTbcjD3AexCOQfIdXdwMyWtA_u2CgwIuLla1zYTJncS5oQjh4U4rpPLDb89SVfOLdK1bjAfI5e-T6S4geugv7ihRl05awqtelANazo9U0ZSoewe6SG4QaIIDbSTp7ObEGMPJPm-K7IgD5nOSYOSc1PHkNXj_r07oiwDkdAEEgSVO5yWNHa9yI6yHTankwenS0VYcb4SwX1xqa8Mwi2PyEwUvyK4jb2VeZXMzZ3rq-HBggmmiHJt-w6Wv_6PZVx75I8ABCAqAdzoyijlHiWroMa0yVclMikub2op7P_MlbW7WTdVALMGmS3IP";
  } else {
    axios.defaults.headers.common["Authorization"] = "";
    delete axios.defaults.headers.common["Authorization"];
  }
};

ServiceApi.logout = () => {
  ServiceStorage.clearToken();
  ServiceApi.setToken();
  //window.location.href = 'https://localhost:9004/home';
  //window.location.href = '/';
  //window.location.href = ServiceApi.defaults.baseURL + "home";
};

ServiceApi.getErrorText = (ex) => {
  let errorText = "An unknown error occurred.";
  if (ex === undefined || ex.response === undefined || ex.response.status === undefined) {
    //errorText = errorText;
    errorText = "Can not connect to server.";
    // } else if (ex.response.status === 403) {
    //   errorText = "You have not required role to do this.";
  } else if (ex.response.status === 403 || ex.response.status === 401) {
    //ServiceApi.logout();
    // ServiceStorage.clearToken();
    // ServiceApi.setToken();
    // window.location.href = 'https://localhost:9004/home';
  } else if (ex.response.data !== undefined && ex.response.data.error_description !== undefined) {
    errorText = ex.response.data.error_description;
  } else if (ex.response.data !== undefined && ex.response.data.message !== undefined) {
    errorText = ex.response.data.message;
  }

  if (errorText && typeof errorText === "object" && errorText.constructor === Array) {
    errorText = errorText.join("\n");
  }

  if (ex === undefined || ex.response === undefined || ex.response.status === undefined) {
    //errorText = errorText;
    errorText = "Can not connect to server.";
  } else if ([400].includes(ex.response.status)) {
    // نمایش خطا ها روی صفحه به کاربر
    //validation Error
    let message = "";
    if (_.isObject(ex.response.data.errors) || _.isObject(ex.response.data.Errors)) {
      let errors = _.isObject(ex.response.data.errors) ? ex.response.data.errors : (_.isObject(ex.response.data.Errors) ? ex.response.data.Errors : {})
      Object.entries(errors).map(([key, value]) => {
        message = message + value + "<br/>";
      });
    }
    else {
      if (!_.isEmpty(ex.response.data.errors) || !_.isEmpty(ex.response.data.Errors)) {
        let errors = !_.isEmpty(ex.response.data.errors) ? ex.response.data.errors : (!_.isEmpty(ex.response.data.Errors) ? ex.response.data.Errors : []);
        errors.map((itemData, index) => {
          message = message + itemData + "<br/>";
        });
      }
      else {
        if (ex && ex.response && ex.response.data && ex.response.data.title) {
          message = ex.response.data.title;
        }
      }
    }

    SwalMessage({ title: message, iSsuccess: false });

  } else if ([500].includes(ex.response.status)) {
    //  تمامی پارامترهای ورودی پاس داده نشده اند
    // و یا خطایی رخ داده در سرور
    SwalMessage({ title: ex.response.data.Message, iSsuccess: false });
  }

  return errorText;
};

ServiceApi.hasToken = () => {
  const access_token = ServiceStorage.getAccessToken();

  if (access_token) {
    return true;
  } else {
    return false;
  }
};

ServiceApi.setToken();

export default ServiceApi;
